import withProxy from "../helpers/proxy.js";
import datasharesData from "./datashares.json";
import maintainerData from "./maintainers.json";

const datashares = datasharesData.records.map(({ fields }) => ({
  name: fields.Name,
  region: fields.Region,
  description: fields.Description,
  featured: fields.featured,
  internal: !fields.isPublic,
  loginRequired: fields.loginRequired,
  maintainers: maintainerData.records
    .filter(({ id }) => (fields.maintainers || []).includes(id))
    .map(maintainer => maintainer.fields)
    .sort((a, b) => a.name.localeCompare(b.name)),
  scope: fields.scope,
  tags: fields.tags?.sort((a, b) => a.localeCompare(b)),
  url: withProxy(fields.docsUrl),
}));

export default datashares;
